import { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { colors } from "@/theme";
import { ProductCard } from "@/components/ProductCard";
import { ProductGridSkeleton, EmptyState, SectionTitle } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function Category() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const urlSub = params.get("sub") || "";
  const [category, setCategory] = useState(null);
  const [sub, setSub] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    setSub(urlSub);
    api(`/categories/${id}`).then(setCategory).catch(() => setCategory(null));
  }, [id, urlSub]);

  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams({ category: id, ...(sub ? { subcategory: sub } : {}) }).toString();
    api(`/products?${qs}`).then(setProducts).finally(() => setLoading(false));
  }, [id, sub]);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 32px" : "40px 24px 48px" }}>
      <div className="eyebrow" style={{ marginBottom: 8 }}>
        <Link to="/" style={{ color: colors.mutedText, textDecoration: "none" }}>Shop</Link> / {category?.name || "…"}
      </div>
      <SectionTitle title={category?.name || "Category"} />

      {category?.subcategories?.length > 0 && (
        <div className="no-scrollbar" style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 8, marginBottom: 24 }}>
          <button className={`chip ${sub === "" ? "chip-active" : ""}`} data-testid="subcat-all" onClick={() => setSub("")}>All</button>
          {category.subcategories.map((s) => (
            <button key={s.id} data-testid={`subcat-${s.id}`} className={`chip ${sub === s.id ? "chip-active" : ""}`} onClick={() => setSub(s.id)}>
              {s.name}
            </button>
          ))}
        </div>
      )}

      {loading ? <ProductGridSkeleton /> : products.length === 0 ? (
        <EmptyState title="Nothing here yet" message="No products available in this category at the moment." />
      ) : (
        <div className="product-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
